/*
 * File: quick.ts
 * Created: 2026-02-05
 * Author: Val Liu
 */

import { PARAMS_INCLUDE, PARAMS_WHERE } from "@/views/core";
import { ObjectHelper } from "@root/core";
import { IQuickUnit, UIQuick } from "@root/core/utilities/quick-helper";

const _ = UIQuick.getInstance;

@UIQuick.set()
export class FailedJob extends IQuickUnit {
    title = "w_MenuTranslateError";
    path = "/translation-job";
    icon = "fa-solid fa-bug";

    /// hierarchy
    parents = () => [_`Organization`];
    children = null;

    /// file
    file = ["inputFile", "outputFile"];

    /// params
    paramsWhere = PARAMS_WHERE;
    paramsRead = function (this: IQuickUnit) {
        return ObjectHelper.deepMerge(
            {
                orderBy: [
                    {
                        createdAt: "desc",
                    },
                ],
                include: {
                    user: true,
                    organization: true,
                },
            },
            PARAMS_INCLUDE.call(this),
        );
    };

    allowCreate = false;
    allowUpdate = false;
    allowDelete = false;

    /// interfaces
    infDetail = require("raw-loader!./interfaces/failed-job.read.interface").default;
    infRead = require("raw-loader!./interfaces/failed-job.read.interface").default;
    infCreate = require("raw-loader!./interfaces/failed-job.read.interface").default;
    infUpdate = require("raw-loader!./interfaces/failed-job.read.interface").default;
    infDelete = require("raw-loader!./interfaces/failed-job.read.interface").default;
}
